import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    KYC_STATE_DECLINED,
    KYC_STATE_RETRY,
    KYC_STATE_VALIDATED,
    KYC_USE_CASE_DECLINED_PURCHASE,
    KYC_USE_CASE_FAILURE_BANK_TRANSFER
} from '../../../../services/kyc/constants';
import { PATH } from '../../../../constants/path';
import { MODAL_TYPE_KYC } from '../../../../services/modal/constants';
import { DECLINED_PAYMENT_CODE } from '../../../../services/checkout/constants';

import { resetKyc } from '../../../../services/kyc/actions';
import { showModal } from '../../../../services/modal/actions';
import { fetchIsIdentityVerified } from '../../../../services/account/identity/actions';

import {
    getLastUserInfoStored,
    isFailureBankTransferEnabled
} from '../../../../utils/storageUtils';
import { getMerchantCardUrl } from '../../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import { LoadingComponent } from '../../../loading/LoadingComponent';

import KycBloc from './KycBloc';
import BankTransferBloc from './BankTransferBloc';
import BackToEbonsButton from './BackToEbonsButton';

const getKycUseCase = (identityVerified, failureBankTransferEnabled, status) => {
    if (identityVerified) return null;
    if (failureBankTransferEnabled) return KYC_USE_CASE_FAILURE_BANK_TRANSFER;
    if (status === DECLINED_PAYMENT_CODE) return KYC_USE_CASE_DECLINED_PURCHASE;
    return null;
};

const PaymentFailureBloc = ({
    i18n,
    paymentId,
    status,
    partner,
    history,
    kycState,
    identityVerified,
    identityVerifiedFetching,
    showModal,
    resetKyc,
    fetchIsIdentityVerified
}) => {
    const userInfo = getLastUserInfoStored();
    const hasPhoneNumber = !!(userInfo && userInfo.phoneNumber);
    const failureBankTransferEnabled = isFailureBankTransferEnabled();

    const kycUseCase = getKycUseCase(identityVerified, failureBankTransferEnabled, status);
    // premier cas KYC conservé jusqu'à l'issue de la vérification
    const [kycErrorCase, setKycErrorCase] = useState(null);

    useEffect(() => {
        fetchIsIdentityVerified();
    }, []);

    useEffect(() => {
        if (kycUseCase && !kycErrorCase) setKycErrorCase(kycUseCase);
    }, [kycUseCase]);

    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            fetchIsIdentityVerified();
            if (kycErrorCase === KYC_USE_CASE_DECLINED_PURCHASE) {
                resetKyc();
                redirectToMerchantCard();
            }
        }
        if (kycState === KYC_STATE_DECLINED || kycState === KYC_STATE_RETRY) {
            if (kycErrorCase === KYC_USE_CASE_FAILURE_BANK_TRANSFER) {
                resetKyc();
                redirectToMerchantCard();
            }
        }
    }, [kycState]);

    const redirectToMerchantCard = () => {
        if (partner && partner.id) {
            history.push(getMerchantCardUrl(partner, false, true));
        } else {
            history.push(PATH.HOME_PATH);
        }
    };

    const showKycModal = () => {
        showModal(MODAL_TYPE_KYC, {
            hideCloseButton: true,
            useCase: kycErrorCase
        });
    };

    const showKyc = !!kycUseCase && hasPhoneNumber;
    const showBankTransfer =
        failureBankTransferEnabled && !kycUseCase && !!paymentId && hasPhoneNumber;

    return (
        <React.Fragment>
            <p>{convertHtmlToReactDomWithParams(i18n.TEXT_1)}</p>
            <div className="reasons">
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT_2)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT_3)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT_4)}</li>
                </ul>
            </div>
            <p>{i18n.TEXT_5}</p>
            <p>{i18n.TEXT_6}</p>
            <br />

            {identityVerifiedFetching ? (
                <div className="loading">
                    <LoadingComponent />
                </div>
            ) : (
                <React.Fragment>
                    <div className="conteneur-color">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT_7)}</p>
                        {showKyc && <BackToEbonsButton text={i18n.BUTTON_TEXT} />}
                    </div>

                    {(showBankTransfer || showKyc) && <p>{i18n.TEXT_OR}</p>}
                    {showBankTransfer && <BankTransferBloc i18n={i18n} paymentId={paymentId} />}
                    {showKyc && <KycBloc i18n={i18n} onStart={showKycModal} />}
                    {!showKyc && <BackToEbonsButton text={i18n.BUTTON_TEXT} />}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

PaymentFailureBloc.propTypes = {
    i18n: PropTypes.object.isRequired,
    paymentId: PropTypes.string,
    status: PropTypes.string,
    partner: PropTypes.object
};

const mapStateToProps = state => {
    return {
        kycState: state.kyc.state,
        identityVerified: state.account.identity.verified,
        identityVerifiedFetching: state.account.identity.fetching
    };
};

const mapDispatchToProps = {
    showModal,
    resetKyc,
    fetchIsIdentityVerified
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentFailureBloc));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/PaymentFailureBloc.js